import { render, staticRenderFns } from "./product-content.vue?vue&type=template&id=142349c6&scoped=true&"
import script from "./product-content.vue?vue&type=script&lang=js&"
export * from "./product-content.vue?vue&type=script&lang=js&"
import style0 from "./product-content.vue?vue&type=style&index=0&id=142349c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142349c6",
  null
  
)

export default component.exports